import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { AuthTransactionAction, CoreState } from "@obg/ngx.core";

import { SgaLoginUiFlowService } from "../sga-login-flow.service";
import { SGA_VERIFICATION_TRANSACTION_PREFIX } from "../sga-login.const";
import { BusyMessage, SgaLoginData } from "../sga-login.model";

import { VerificationLoginData } from "./verification-login.model";

@Component({
	selector: "obg-m-verification-sga-login-container",
	templateUrl: "./verification-sga-login.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	providers: [SgaLoginUiFlowService],
})
export class VerificationSgaLoginContainer {
	readonly translationPrefix = SGA_VERIFICATION_TRANSACTION_PREFIX;
	description = `${this.translationPrefix}.description`;

	@Output() busy = new EventEmitter<BusyMessage>();
	@Input() set verificationLoginData(data: VerificationLoginData | undefined) {
		if (data?.message) {
			this.description = data.message;
		}
	}

	constructor(
		private store: Store<CoreState>,
		private authTransactionAction: AuthTransactionAction
	) {}

	login(data: SgaLoginData) {
		this.store.dispatch(
			this.authTransactionAction.initializeVerification({
				personalNumber: data.personalNumberForm.controls.personalNumber.value,
				token: data.loginToken,
			})
		);
	}
}
